import { takeLatest } from "redux-saga/effects";
import {
  GetUpcomingAppointment,
  getProvidersList,
  getFacilityList,
  addAppointment,
  addAppointmentWaitList,
  editAppointmentWaitList,
  AppointmentEdited,
  getProviderAvailablity,
  GetPastAppt,
  GetCancelAppt,
  deleteWaitList,
  getPortalAppAvailablity,
  getOnsiteAppReq,
  GetBillingFacility,
} from "../../StateManagement/Reducers/AppointmentsState";
import {
  upcomingAppointments,
  providersWorker,
  facilityWorker,
  AddAppointmentWorker,
  AddWaitListAppointmentWorker,
  EditWaitListAppointmentWorker,
  EditAppointmentWorker,
  SetAvailablityWorker,
  PastApptAPi,
  CancelApptApi,
  deleteWaitlistApi,
  SetPortalAppAvailablityWorker,
  SetOnsiteAppReqWorker,
  BillingFacilityWorker,
} from "./AppointmentsSagaWorkers";

export function* upcomingAppointmentsSaga() {
  yield takeLatest(GetUpcomingAppointment.type, upcomingAppointments);
}
export function* PastApptSaga() {
  yield takeLatest(GetPastAppt.type, PastApptAPi);
}
export function* CancelApptSaga() {
  yield takeLatest(GetCancelAppt.type, CancelApptApi);
}
export function* deleteWaitlistSaga() {
  yield takeLatest(deleteWaitList.type, deleteWaitlistApi);
}

export function* GetProviderSaga() {
  yield takeLatest(getProvidersList.type, providersWorker);
}
export function* GetFacilitySaga() {
  yield takeLatest(getFacilityList.type, facilityWorker);
}
export function* SaveAppointmentSaga() {
  yield takeLatest(addAppointment.type, AddAppointmentWorker);
}
export function* SaveWaitListAppointmentSaga() {
  yield takeLatest(addAppointmentWaitList.type, AddWaitListAppointmentWorker);
}
export function* EditWaitListAppointmentSaga() {
  yield takeLatest(editAppointmentWaitList.type, EditWaitListAppointmentWorker);
}
export function* EditAppointmentSaga() {
  yield takeLatest(AppointmentEdited.type, EditAppointmentWorker);
}
export function* getProviderAvailablitySaga() {
  yield takeLatest(getProviderAvailablity.type, SetAvailablityWorker);
}
export function* getPortalAppAvailablitySaga() {
  yield takeLatest(getPortalAppAvailablity.type, SetPortalAppAvailablityWorker);
}
export function* getOnsiteAppReqSaga() {
  yield takeLatest(getOnsiteAppReq.type, SetOnsiteAppReqWorker);
}

export function* BillingFacilitySaga() {
  yield takeLatest(GetBillingFacility.type, BillingFacilityWorker);
}
